import { Task } from '@/types';

export const mockTasks: Task[] = [
  {
    id: 'task-1',
    title: 'Complete Math Recovery Assignment',
    description: 'Student needs to complete missing algebra assignments from last week to improve current grade',
    assignedTo: 'ST0001',
    dueDate: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString(),
    status: 'in_process',
    priority: 'high',
    category: 'academic',
    reminders: [
      new Date(Date.now() + 5 * 24 * 60 * 60 * 1000).toISOString()
    ],
    attachments: [],
    comments: [
      {
        id: 'comment-1',
        userId: 'counselor-1',
        content: 'Student has agreed to attend after-school tutoring sessions',
        timestamp: new Date().toISOString()
      }
    ],
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: 'task-2',
    title: 'Attendance Improvement Plan',
    description: 'Create and implement attendance improvement plan due to 3 unexcused absences this month',
    assignedTo: 'ST0002',
    dueDate: new Date(Date.now() + 3 * 24 * 60 * 60 * 1000).toISOString(),
    status: 'not_started',
    priority: 'high',
    category: 'attendance',
    reminders: [],
    attachments: [],
    comments: [],
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: 'task-3',
    title: 'Parent-Teacher Conference Follow-up',
    description: 'Schedule follow-up meeting to discuss progress since last conference',
    assignedTo: 'ST0003',
    dueDate: new Date(Date.now() + 14 * 24 * 60 * 60 * 1000).toISOString(),
    status: 'completed',
    priority: 'medium',
    category: 'academic',
    reminders: [],
    attachments: [
      {
        id: 'attachment-1',
        name: 'Meeting Notes.pdf',
        url: '/files/meeting-notes.pdf'
      }
    ],
    comments: [
      {
        id: 'comment-2',
        userId: 'counselor-1',
        content: 'Parents confirmed availability for next week',
        timestamp: new Date().toISOString()
      }
    ],
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: 'task-4',
    title: 'College Application Support',
    description: 'Assist with college application essays and submission process',
    assignedTo: 'ST0004',
    dueDate: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString(),
    status: 'in_process',
    priority: 'medium',
    category: 'academic',
    reminders: [],
    attachments: [],
    comments: [],
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: 'task-5',
    title: 'Study Skills Workshop',
    description: 'Enroll student in upcoming study skills workshop to improve academic performance',
    assignedTo: 'ST0005',
    dueDate: new Date(Date.now() + 10 * 24 * 60 * 60 * 1000).toISOString(),
    status: 'not_started',
    priority: 'low',
    category: 'academic',
    reminders: [],
    attachments: [],
    comments: [],
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: 'task-6',
    title: 'Behavioral Intervention Plan Review',
    description: 'Review and update current behavioral intervention plan with teaching staff',
    assignedTo: 'ST0006',
    dueDate: new Date(Date.now() + 5 * 24 * 60 * 60 * 1000).toISOString(),
    status: 'in_process',
    priority: 'high',
    category: 'behavioral',
    reminders: [],
    attachments: [],
    comments: [
      {
        id: 'comment-3',
        userId: 'counselor-2',
        content: 'Initial meeting with teachers scheduled for tomorrow',
        timestamp: new Date().toISOString()
      }
    ],
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: 'task-7',
    title: 'Grade Improvement Plan',
    description: 'Develop plan to improve grades in English and History classes',
    assignedTo: 'ST0007',
    dueDate: new Date(Date.now() + 2 * 24 * 60 * 60 * 1000).toISOString(),
    status: 'completed',
    priority: 'medium',
    category: 'academic',
    reminders: [],
    attachments: [],
    comments: [],
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: 'task-8',
    title: 'Tutoring Program Enrollment',
    description: 'Enroll student in after-school tutoring program for math support',
    assignedTo: 'ST0008',
    dueDate: new Date(Date.now() + 1 * 24 * 60 * 60 * 1000).toISOString(),
    status: 'not_started',
    priority: 'medium',
    category: 'academic',
    reminders: [],
    attachments: [],
    comments: [],
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: 'task-9',
    title: 'Mental Health Check-in',
    description: 'Schedule regular check-in with school counselor for emotional support',
    assignedTo: 'ST0009',
    dueDate: new Date(Date.now() + 4 * 24 * 60 * 60 * 1000).toISOString(),
    status: 'in_process',
    priority: 'high',
    category: 'health',
    reminders: [],
    attachments: [],
    comments: [],
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: 'task-10',
    title: 'Attendance Recovery Plan',
    description: 'Create plan to make up missed assignments and improve attendance',
    assignedTo: 'ST0010',
    dueDate: new Date(Date.now() + 6 * 24 * 60 * 60 * 1000).toISOString(),
    status: 'not_started',
    priority: 'high',
    category: 'attendance',
    reminders: [],
    attachments: [],
    comments: [],
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  }
];